import { useState } from "react"
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from "@/Components/ui/dialog"

export default function WatchlistModal({
    open,
    onOpenChange,
    onSubmit,
    brandName,
}) {
    const [email, setEmail] = useState("")
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState(null)

    const reset = () => {
        setEmail("")
        setError(null)
        setSubmitting(false)
    }

    const handleClose = (next) => {
        if (!next) reset()
        onOpenChange(next)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError(null)

        if (!/^\S+@\S+\.\S+$/.test(email)) {
            setError("Please enter a valid email address.")
            return
        }

        try {
            setSubmitting(true)
            await onSubmit?.({ email: email.trim() })
            handleClose(false)
        } catch {
            setError("Something went wrong. Please try again.")
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="bg-white sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Add to Watchlist</DialogTitle>
                    <DialogDescription>
                        {brandName
                            ? `We’ll email you when ${brandName} auctions go live.`
                            : "We’ll email you when new auctions match your watchlist."}
                    </DialogDescription>
                </DialogHeader>

                <form onSubmit={handleSubmit} className="pt-2 space-y-4">
                    <div className="space-y-1.5">
                        <label
                            htmlFor="watchlist-email"
                            className="text-sm font-medium text-gray-900"
                        >
                            Email
                        </label>
                        <input
                            id="watchlist-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            required
                            autoFocus
                            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-[#800020] focus:ring-2 focus:ring-[#800020]/20 focus:outline-none"
                        />
                    </div>

                    {error && (
                        <p role="alert" className="text-sm text-red-600">
                            {error}
                        </p>
                    )}

                    <DialogFooter className="gap-2 sm:gap-2">
                        <button
                            type="button"
                            onClick={() => handleClose(false)}
                            disabled={submitting}
                            className="px-4 py-2 text-sm font-medium text-gray-800 transition bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={submitting}
                            className="rounded-md bg-[#800020] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#651318] disabled:opacity-50"
                        >
                            {submitting ? "Adding…" : "Add to Watchlist"}
                        </button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    )
}
